module.exports = __webpack_public_path__ + "static/img/c10.5a8d574.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/c10.png
// module id = nK5H
// module chunks = 0